import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import CommonPage from "../common/CommonPage";
import { useGetProfile } from '../../../hooks/profile/useGetProfile';
import { useDeleteProfile } from '../../../hooks/profile/useDeleteProfile';
import { CALL_STATUS } from '../../../store/reducers/constants';

const ProfilePage = () => {
    const profile = useGetProfile();
    const { handleDelete, deleteStatus } = useDeleteProfile();
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const handleOpenDialog = () => setOpenConfirmDialog(true);
    const handleCloseDialog = () => setOpenConfirmDialog(false);

    const handleConfirmDelete = () => {
        handleDelete();
    };

    return (
        <CommonPage>
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Avatar
                        sx={{
                            width: 120,
                            height: 120,
                            fontSize: '3.5rem',
                            bgcolor: 'primary.main'
                        }}
                        alt={`Аватар пользователя ${profile.login}`}
                    >
                        {profile.login ? profile.login.charAt(0).toUpperCase() : '?'}
                    </Avatar>

                    <Box>
                        <Typography variant="h4" component="h1" gutterBottom>
                            {profile.login}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            {profile.email}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="outlined"
                        color="error"
                        onClick={handleOpenDialog}
                    >
                        Delete My Account
                    </Button>
                </Box>
            </Paper>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Account Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete your account? This action is irreversible. All your data, including uploaded media, will be permanently removed.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} disabled={deleteStatus === CALL_STATUS.PENDING}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmDelete}
                        color="error"
                        disabled={deleteStatus === CALL_STATUS.PENDING}
                    >
                        {deleteStatus === CALL_STATUS.PENDING ? <CircularProgress size={24} /> : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </CommonPage>
    );
}

export default ProfilePage;